import styled from "styled-components";

export const StyledTableContainer = styled.div`
  /* Table Background and Border Colors */
  --table-bg: #ffffff;
  --table-header-bg: #76C4E8;
  --table-header-border-color: #34b5f4;
  --tbody-column-border-color: #afe5ff;
  --table-header-color: #1F4971;
  --table-row-odd-bg: #DDF4FF;
  --table-row-selected-bg: #2C78A9;
  --table-row-selected-color: #FFFFFF;
  --table-row-selected-odd-bg: rgb(197, 237, 255);
  --table-row-selected-even-bg: rgb(227,246,254);
  --tbody-column-sort: #b9e5fa;
  --table-cell-row-hover: rgba(163, 229, 255, 0.25);
  --table-cell-sort: rgba(163, 229, 255, 0.35);

  /* Table Wrapper Styles */
  .ant-table-wrapper {
    background: var(--table-bg);
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    box-shadow: 1px 1px 2px 0px rgba(0, 0, 0, 0.2);
    
    /* Table Common Style */
   .ant-table .ant-table-thead .ant-table-cell{
     border-radius: 0 !important;
   }

    .ant-table .ant-table-thead .ant-table-cell,
    .ant-table-tbody .ant-table-row .ant-table-cell {
      font-weight: 500;
      font-size: 14px;
      color: #1a1f22;
    }
  
    .ant-table-tbody .ant-table-placeholder{
        .ant-table-cell{
          color: rgba(0, 0, 0, 0.52);
          font-weight: 500;
          padding-top:20px;
          padding-bottom:20px;
        }
    }
     
    .ant-table {
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;

      table {
        border-radius: 0 !important;
      }
    }
      

  }

  /* Table Pagination Styles */
  .ant-table-pagination.ant-pagination {
    margin: 0;
    padding: 15px;

    .ant-pagination-options {
      .ant-select-selector {
        box-shadow: none !important;
        border-width: 1px;
        cursor:pointer;
      }
      .ant-select-selector:not(.ant-select-disabled).ant-select-open {
        box-shadow: 0 0 0 2px var(--core-highlight-color) !important;
      }
    }
    .ant-pagination-item-active{
    cursor:default;
     a{
     cursor:default;
     }
    }
    .ant-pagination-item-active a,
    .ant-select-selector:not(.ant-select-disabled) .ant-select-selection-item,
    .ant-select-arrow {
      color: var(--text-blue-dark);
    }
  }
  .ant-table-tbody .ant-table-row.ant-table-row-selected{
    cursor:default !important;
  }
  /* Table Layout and Borders */
  .ant-table-wrapper:not(.table-outlined) {

    .ant-table {

      /* Table Header Styles */
      .ant-table-thead .ant-table-cell {
        background: var(--table-header-bg);
        color: var(--table-header-color);
        text-transform: uppercase;
        font-weight: 600;
        border-right-color: var(--table-header-border-color) !important;
        border-bottom-color: var(--table-header-border-color) !important;
        border-top-color: transparent !important;
        border-radius: 0 !important;
      }

      /* Table Body Styles */
      .ant-table-tbody .ant-table-row .ant-table-cell {
        border-right-color: var(--tbody-column-border-color) !important;
      }

      .ant-table-tbody .ant-table-row:nth-child(odd) {
        .ant-table-cell {
          background: var(--table-row-odd-bg);
        }
      }

      /* Row Selection Styles */
      .ant-table-tbody .ant-table-row-selected .ant-table-cell {
        background: var(--table-row-selected-bg) !important;
        border-right-color: #1f86c8 !important;
        color: var(--table-row-selected-color);
      }
    }
  }

  /* Sorting Styles */

  .ant-table-thead{
    .ant-table-cell.ant-table-column-sort {
      background: var(--table-row-selected-bg) !important;
      color: #fff !important;
    }
  }
    
  .ant-table-tbody .ant-table-row:nth-child(even) {
    .ant-table-column-sort {
      background:var(--table-row-selected-even-bg) !important;
    }
  }

  .ant-table-tbody .ant-table-row:nth-child(odd) {
    .ant-table-column-sort {
      background:var(--table-row-selected-odd-bg) !important;
    }
  }

  /* Row Hover Effects */
  .ant-table-tbody .ant-table-row:not(.ant-table-row-selected) {
    &:not(.ant-table-placeholder) {
      .ant-table-cell:not(.ant-table-column-sort).ant-table-cell-row-hover {
        background: var(--table-cell-row-hover);
      }
    }
  }

  /* Table Header Sorting Icon */
  .ant-table-cell {
     
    .custom-sort-icon {
      padding-top: 2px;
      padding-left: 3px;
      
      span {
        display: block;
      }

      span + span {
        margin-top: -7px;
      }
      &:not(.custom-sort-default){
      color: #8bddff;
      }
      &.custom-sort-default {
        opacity: 0.85;

        span + span {
          margin-top: -5px;
        }
      }
    }
  }
  
  /* Table Outlined Styles */
  .table-outlined {
      --table-row-selected-bg:rgba(4, 42, 67, 0.2);
      --table-row-selected-odd-bg: rgba(4, 42, 57, 0.08);
      --table-row-selected-even-bg: rgba(4, 42, 57, 0.05);
      --table-cell-row-hover: rgba(4, 42, 67, 0.1);

      .ant-table-wrapper .ant-table-thead .ant-table-cell{
          background: #ffffff;
      }
      .ant-table-thead .ant-table-cell.ant-table-column-sort{
        color: #1a1f22;
      }
      .ant-table-tbody .ant-table-row.ant-table-row-selected .ant-table-cell {
        background: var(--table-row-selected-bg) !important;
      }
      
       .ant-table-thead .custom-sort-icon {
        color: #757575;
        &:not(.custom-sort-default){
         color:#24709d;
        }
      }
      
   }
  
   .ant-table-empty .ant-table-cell.ant-table-column-has-sorters{
         pointer-events: none;
   }
   
   /* Table Selection Hide */
    .selection-element-hide {
      .ant-table-cell.ant-table-selection-column,
      ant-table-cell.ant-table-selection-column,
      .ant-table-selection-col,
      col {
        display:none;
        width: 0px !important;
        max-width: 0px !important;
        min-width: 0px !important;
        padding: 0 !important;
        border-right-width: 0px !important;
        border-left-width: 0px !important;
        font-size: 0 !important;
        flex-grow: 0 !important;
        flex-shrink: 0 !important;
        flex-basis: 0 !important;      
       
        > * {
          display: none;
        }
      }
    }
   
    .ant-table-header{
        border-top-right-radius: 0px !important;
        border-top-left-radius: 0px !important;
        th{
        
        }
    }
    .ant-table-tbody-virtual-holder-inner{
       
    }
   .ant-table-tbody .ant-table-measure-row{
     
   }
  
   --scrollbar-color-thumb: rgba(0, 0, 0, 0.19);
   --scrollbar-color-track: rgba(0, 0, 0, 0.09);
   --scrollbar-width: thin;
   
   .ant-table-content,.ant-table-body {
      scrollbar-color: var(--scrollbar-color-thumb) var(--scrollbar-color-track);
      scrollbar-width: var(--scrollbar-width);
    }
      
    .ant-table:not(.ant-table-fixed-header) .ant-table-content{
      max-height:calc(100dvh - 194px);
      overflow: auto !important;
    }

    .ant-spin.ant-spin-spinning{
        .ant-spin-text{
          color: #042a43;
          text-shadow: none !important;
          font-weight: 500;
        }
        .ant-spin-dot-holder{
          color: #000000;
        }
    }
    .ant-spin-container.ant-spin-blur::after{
      opacity: 0.55;
      background: #dbeff9;
    }
    
    .table-has-fixed-header{
      .ant-table:not(.ant-table-fixed-header){
        .ant-table-thead{
            position: sticky;
            top: 0;
            z-index: 12;
          }
        }
      } 
    }

`;
